import { Suspense } from 'react'
import { colors } from '@lmc/common/constants'
import Field from '../../../fields'

interface OverTheCounterFieldProps {
  confirmProps: Record<string, any>
  fields: Record<string, any>
  formId: string
  onConfirm: (key: string, value: any) => void
  requireConfirm: boolean
}

/**
 * @description Renders OverTheCounterField for the Add Medication modal
 * @param {OverTheCounterFieldProps} props - The component's props.
 * @returns {JSX.Element} OverTheCounterField.
 */
export default function OverTheCounterField(
  props: OverTheCounterFieldProps
): JSX.Element {
  const { confirmProps, fields, formId, onConfirm, requireConfirm } = props

  const title = 'Over the Counter'

  const selectedOptionFieldStyle = requireConfirm ? styles.prepopField : null

  return (
    <div style={styles.userGeneratedFieldContainer}>
      <Suspense fallback={<div>Loading...</div>}>
      <Field
        compact
        confirmProps={confirmProps}
        displayLabel
        fieldType="radios"
        formId={formId}
        hasComment
        helpLink="https://www.cqc.org.uk/guidance-providers/adult-social-care/over-counter-medicines-homely-remedies"
        helpText="OTC and homely remedies"
        keys="overTheCounter"
        label={title}
        layout="no-label"
        onConfirm={onConfirm}
        options={DEFAULT_RADIO_OPTIONS}
        requireConfirm={requireConfirm}
        required
        selectedOptionFieldStyle={selectedOptionFieldStyle}
        type="userGeneratedFieldLayout"
        values={fields}
      />
      </Suspense>
    </div>
  )
}

const DEFAULT_RADIO_OPTIONS = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
]

const styles = {
  prepopField: {
    background: colors.hoverblue,
  },
  userGeneratedFieldContainer: {
    marginBottom: 16,
  },
}
